import { ArrowUDownLeftBoldIcon } from './ArrowUDownLeftBoldIcon';

/**
 * author: Colton Wiscombe
 * id EE6C5398-B666-4BE6-9728-AF35B5C77BA9
 * name arrow-u-down-left-bold
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-u-down-left-bold.svg
 * tags
 */
export const UTurnLeftBoldIcon = ArrowUDownLeftBoldIcon;
export default UTurnLeftBoldIcon